class Coordinates {

    /**
     * @param {CoordinatesObj} coordinates 
     */
    constructor(coordinates) {
        this.x = coordinates.x;
        this.y = coordinates.y;
    }

    /**
     * 
     * @param {CoordinatesObj} other 
     */
     equals(other) {
        return this.x === other.x && this.y === other.y;
    }

    toString() {
        return Coordinates.objToString(this);
    }

    /**
     * 
     * @param {CoordinatesObj} obj 
     */
    static objToString(obj) {
        return `(${obj.x}, ${obj.y})`;
    }
}

export default Coordinates;